<script>
import {onMounted, ref} from "vue";
import useSharedData from "@/use/SharedData";
import axios from "axios";
import useTools from "@/use/Tools";
import {useWorkerStore} from "@/stores/Worker/Worker";
import useSharedMethod from "@/use/SharedMethod";
import useValidation from "@/use/Validation";

export default {
    setup() {
        const {mxRules} = useValidation();
        const {$refs, $route} = useTools();
        const {getBack} = useSharedMethod();
        const {dialog, loading, overlay, overlayOpacity} = useSharedData();
        const workerStore = useWorkerStore();
        const worker = ref({});

        function findById(id) {
            loading.value = true;
            axios.get(`/workers/${id}`).then((response) => {
                worker.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function deactivate() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put('/workers/deactivate', worker.value).then(response => {
                    workerStore.deleteWorker(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        onMounted(() => findById($route.params.id));

        return {
            mxRules,
            dialog,
            loading,
            overlay,
            overlayOpacity,
            worker,
            deactivate,
            getBack,
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="600"
            scrollable
        >
            <v-card>
                <w-toolbar color="grey" :title="$t('common.deactivate')"/>
                <w-overlay
                    :overlay="overlay"
                    :loading="loading"
                    deactivate-action
                    @deactivate="deactivate"
                    @cancel="overlay = false"
                />
                <v-card-text>
                    <v-form ref="form" lazy-validation>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12">
                                    <w-label :label="$t('common.exit_date')" required/>
                                    <w-date-picker
                                        v-model="worker.exitDate"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <w-label :label="$t('data_select.WORKER_EXIT_REASON')" required/>
                                    <w-data-select-autocomplete
                                        v-model="worker.leavingCauseId"
                                        type="CONTRAT_EXIT_RATIONALE"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <w-label :label="$t('common.interim')" :required="worker.head"/>
                                    <str-worker-autocomplete
                                        v-model="worker.interimId"
                                        :rules="worker.head ? [mxRules.required] : []"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn-deactivate
                        show
                        :loading="loading"
                        @press="overlay = true"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>

</style>